import React, { useState, useEffect } from 'react';
import GridItem from '../../components/Grid/GridItem.js';
import GridContainer from '../../components/Grid/GridContainer.js';
import Divider from '@material-ui/core/Divider';
import { makeStyles } from '@material-ui/core/styles';
// core components
import { connect } from 'react-redux';
import { getAllTransactions } from '../../store/actions/vendor/Vendor';
import CardHeader from '../../components/Card/CardHeader.js';
import { Typography } from '@material-ui/core';


const PAGE_LIMIT = 2000
const styles = {
    typo: {
        paddingLeft: '25%',
        marginBottom: '40px',
        position: 'relative'
    },
    note: {
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        bottom: '10px',
        color: '#c0c1c2',
        display: 'block',
        fontWeight: '400',
        fontSize: '13px',
        lineHeight: '13px',
        left: '0',
        marginLeft: '20px',
        position: 'absolute',
        width: '260px'
    },
    cardCategoryWhite: {
        color: 'rgba(255,255,255,.62)',
        margin: '0',
        fontSize: '14px',
        marginTop: '0',
        marginBottom: '0'
    },
    cardTitleWhite: {
        color: '#FFFFFF',
        marginTop: '0px',
        minHeight: 'auto',
        fontWeight: '300',
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: '3px',
        textDecoration: 'none'
    }
};

const useStyles = makeStyles(styles);

const UsersTable = (props) => {
    const classes = useStyles();


    useEffect(() => {
        props.getAllTransactions(1, 10000, props.match.params.id);
    }, []);

  

    const renderTransaction = (t) => {
        return (
            <div>
                <GridContainer style={{color:'black'}}>
                    <GridItem xs={12} sm={12} md={6} >
                        <GridContainer>
                            <GridItem xs={8} sm={8} md={8} >
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                    <Typography component="p" style={{color:'black'}}>{t.addedToWallet ? 'Added to Wallet' : 'Paid from Wallet'}</Typography>
                                    <Typography component="p" style={{color:'black'}}>{new Date(t.createdAt).toLocaleString()}</Typography>
                                    <Typography component="p" style={{color:'black'}}><b>Order Ref No -</b> {t.orderRef}</Typography>
                                </div>
                            </GridItem>
                        </GridContainer>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6} style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                    <Typography component="span" style={{ color: t.addedToWallet ? 'rgb(1, 160, 90)' : 'red',fontWeight:'bold' }}>{t.data&&t.data.currency} {t.amount}</Typography>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12} style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', marginTop: '2%' }}>
                    <Typography component="p" style={{ color: 'green',fontWeight:'bold' }}>{t.status}</Typography>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12} style={{ marginTop: '2%', marginBottom: '2%' }}>
                        <Divider></Divider>
                    </GridItem>
                </GridContainer>
            </div>
        )
    }
    return (
        <>
            <CardHeader color="primary">
                <h4 className={classes.cardTitleWhite}>
                    Transactions
        </h4>
            </CardHeader>
            <br/>
            {props.transactions?.map((t) => {
                                    return <GridItem xs={12} style={{ textAlign: 'left' }}>
                                        {renderTransaction(t)}
                                    </GridItem>
                                })}
        </>
    );
};

const mapStateWithProps = (state) => ({
    transactions: state.vendor.transactions?.data,
});
const mapDispatchWithProps = (dispatch) => {
    return {
        getAllTransactions: (pageNumber, count) => dispatch(getAllTransactions(pageNumber, count)),
    };
};

export default connect(mapStateWithProps, mapDispatchWithProps)(UsersTable);
